document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
        const upsell = document.querySelector(".js-minicart-upsell");
        if (!upsell) return;

        const productId = upsell.getAttribute("data-product-id");
        const variantId = upsell.getAttribute("data-variant-id");

        const qty = upsell.querySelector(".js-quantity-incrementor");
        if (!qty) return;

        const amount = qty.querySelector(".js-quantity-amount");
        const minus = qty.querySelector(".js-quantity-minus");
        const plus = qty.querySelector(".js-quantity-plus");
        if(!amount || !minus || !plus) return;

        const limit = Number(window.upsell.productLimit);

        showUpsell(upsell);

        minus?.addEventListener("click", () => {
            fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
                const items = data.items;
                const targetItem = items.find(item => 
                    String(item.product_id) === String(productId) &&
                    Number(item.id) === Number(variantId)
                );

                if (!targetItem) {
                    console.log("Minicart upsell: Producto it's not in the cart.");
                    return;
                }

                const currentQty = Number(targetItem.quantity) || 0;
                const reduceBy = Number(amount.getAttribute("data-amount")) || 1;
                const newQty = currentQty - reduceBy;

                if (newQty > 0) {
                    updateUpsellQty(variantId, Number(newQty));
                } else {
                    updateUpsellQty(variantId, 0);
                }

                return data;
            });
        });

        plus?.addEventListener("click", () => {
            fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
                const items = data.items;

                const totalQty = items.filter(item => String(item.product_id) === String(productId)).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
                const limitReached = totalQty >= Number(limit);

                if(limitReached) {
                    console.log("Minicart upsell: Product is already in the cart!");
                }  else {
                    upsellAddToCart(variantId, Number(amount.getAttribute("data-amount")));
                }

                return data;
            });
        });
        
        const targetNode = document.querySelector('.minicart');
        if (targetNode) {
            const config = { attributes: true, attributeFilter: ['data-items-count'] };

            let debounceTimer;

            const callback = (mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-items-count') {
                        clearTimeout(debounceTimer);
                        debounceTimer = setTimeout(async () => {
                            try {
                                const response = await fetch(window.Shopify.routes.root + 'cart.js');
                                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

                                const data = await response.json();
                                const items = data.items || [];
                                const triggerList = window.upsell?.triggerList || [];

                                const foundInCart = triggerList.some(trigger =>
                                    items.some(item => String(item.product_id) === String(trigger.id))
                                );

                                document.querySelector(".js-minicart-upsell")?.classList.toggle("hidden", !foundInCart);
                            } catch (error) {
                                console.error("Error fetching cart data:", error);
                            }
                        }, 300);
                    }
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }

        function showUpsell(component) {
            fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
                const items = data.items;
                const triggerList = window.upsell.triggerList || [];
                const foundInCart = triggerList.some(trigger => items.some(item => String(item.product_id) === String(trigger.id)));

                if(foundInCart) {
                    component.classList.remove("hidden");
                } else {
                    component.classList.add("hidden");
                }
                
                return data;
            });
        }

        function upsellAddToCart(variantId, qty) {
            let formData = {
                items: [{
                    id: variantId,
                    quantity: qty,
                    properties: {
                        _upsell: "true"
                    }
                }]
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                VueMinicart.config.globalProperties.$store.dispatch('initCart');
                return data;
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }

        function updateUpsellQty(variantId, qty) {
            let updates = {
                [variantId]: qty
            };

            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
            })
            .then(response => response.json())
            .then(data => {
                VueMinicart.config.globalProperties.$store.dispatch('initCart');
                return data;
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
    }, 1000);
});

const checkUpsellOnMinicart = e => {
    setTimeout(() => {
        const minicartUpsell = document.querySelector(".js-minicart-upsell");
        if (!minicartUpsell) return;

        fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
            const items = data.items;
            const triggerList = window.upsell.triggerList || [];
            const foundInCart = triggerList.some(trigger => items.some(item => String(item.product_id) === String(trigger.id)));

            if(foundInCart) {
                minicartUpsell.classList.remove("hidden");
            } else {
                minicartUpsell.classList.add("hidden");
            }
            
            return data;
        });
    }, 100);
};

document.addEventListener('cart.initCart', checkUpsellOnMinicart);
document.addEventListener('cart.addItem', checkUpsellOnMinicart);
document.addEventListener('cart.updateItem', checkUpsellOnMinicart);